import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { ITeacher, listTeachers, createTeacher, updateTeacher, enableTeacher, pageTeachers } from '../../service/api/teacher';
import { IStore, listStores } from '../../service/api/store';
import moment from 'moment';
import { ICardDefinition, listCardDefinitions } from '../../service/api/cardDefinition';
import { ICard, createCard } from '../../service/api/card';
import { FormInstance } from 'antd/lib/form/Form';
import './css.less';
const { confirm } = Modal;
const { Option } = Select;

const TeacherView = (props: any) => {
  const [teachers, setTeachers] = useState<ITeacher[]>();
  // const [stores, setStores] = useState<IStore[]>();
  // const [cardDefinitions, setCardDefinitions] = useState<ICardDefinition[]>();
  const [teacherDetail, setTeacherDetail] = useState<ITeacher>();
  const [buyTeacherDetail, setBuyTeacherDetail] = useState<ITeacher>();
  const [teacherVisible, setTeacherVisible] = useState(false);
  const [buyVisible, setBuyVisible] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [stores, setStores] = useState<IStore[]>();
  const [searchKeyword, setSearchKeyword] = useState<string>();
  const [filterStoreIds, setFilterStoreIds] = useState(undefined);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const formRef = React.createRef<FormInstance>();
  const buyformRef = React.createRef<FormInstance>();
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '性别',
      dataIndex: 'sex',
      key: 'sex',
      render: (text: any, record: any) => {
        if (record.sex == 1) {
          return '男'
        } else {
          return '女'
        }
      }
    },
    {
      title: '联系电话',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: '生日',
      dataIndex: 'birthday',
      key: 'birthday',
      render(val: Date) {
        return val ? moment(val).format('YYYY-MM-DD') : <>&mdash;</>
      },
    },
    {
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
    },
    {
      title: '状态',
      dataIndex: 'enable',
      key: 'enable',
      render: (text: any, record: any) => {
        if (record.enable) {
          return <span style={{ color: 'green' }}>在职</span>
        } else {
          return <span style={{ color: 'grey' }}>离职</span>
        }
      }
    },
    {
      title: '操作',
      key: 'action',
      render: (text: any, record: any) => {
        if (record.enable) {
          return <Space size="middle">
            <a onClick={() => {
              setTeacherDetail(record);
              setTeacherVisible(true);
            }}>编辑 </a>
            <a onClick={e => { onEnable(e, record) }}>离职 </a>
          </Space>
        } else {
          return <Space size="middle">
            <a onClick={() => {
              setTeacherDetail(record);
              setTeacherVisible(true);
            }}>编辑 </a>
            <a onClick={e => { onEnable(e, record) }}>复职 </a>
          </Space>
        }
      },
    }
  ];

  useEffect(() => {
    loadData();
  }, [pageNum, pageSize, filterStoreIds]);

  useEffect(() => {
    if (teacherDetail) {
      let copyFormData = JSON.parse(JSON.stringify(teacherDetail))
      if (typeof (copyFormData.birthday) === 'string') {
        copyFormData.birthday = moment(new Date(teacherDetail.birthday));
      }
      // 设置100毫秒的延迟 确保from组件已经加载完毕
      setTimeout(() => {
        formRef.current!.setFieldsValue(copyFormData);
      }, 100);
    }
    if (buyTeacherDetail) {
      let copyFormData = JSON.parse(JSON.stringify(buyTeacherDetail))
      if (typeof (copyFormData.birthday) === 'string') {
        copyFormData.birthday = moment(new Date(buyTeacherDetail.birthday));
      }
      // 设置100毫秒的延迟 确保from组件已经加载完毕
      setTimeout(() => {
        buyformRef.current!.setFieldsValue(copyFormData);
      }, 100);
    }
  }, [teacherDetail, buyTeacherDetail]);

  const loadData = () => {
    pageTeachers(pageNum, pageSize, filterStoreIds || '',searchKeyword || '').then((info: any) => {
      setTeachers(info?.data.list);
      setPageTotal(info?.data.total);
      // console.log("info:" + JSON.stringify(info.data));
    });
    listStores().then((info: any) => {
      setStores(info?.data);
    });
    // listCardDefinitions().then((info: any) => {
    //   setCardDefinitions(info?.data);
    // });
  }

  const onFinish = (values: any) => {
    setLoading(true);
    if (teacherDetail) {
      updateTeacher({
        ...values,
        id: teacherDetail.id
      }).then((info: any) => {
        console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("更新成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    } else {
      createTeacher(values).then((info: any) => {
        console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("创建成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    }
  };

  const onEnable = (e: any, item: ITeacher) => {
    e.stopPropagation();
    confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: item.enable ? '确定要停用该教师吗？停用后无法被选到' : '确定要启用该教师吗？',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        enableTeacher(item.id, !item.enable).then((info: any) => {
          if (info) {
            message.success("操作成功");
            loadData();
          }
        });
      },
      onCancel() {
      },
    });
  }

  const onClose = () => {
    setTeacherDetail(undefined);
    setBuyTeacherDetail(undefined);
    setTeacherVisible(false);
    setBuyVisible(false);
    if (formRef.current) {
      formRef.current!.resetFields();
    }
    if (buyformRef.current) {
      buyformRef.current!.resetFields();
    }
  }

  const onPageChange = (pageNum: number, pageSize?: number) => {
    console.log("pageNum:" + pageNum);
    console.log("pageSize:" + pageSize);
    setPageNum(pageNum);
    setPageSize(pageSize || 10);
    // setPageSize(info.data.pageSize);
  }

  // // 下拉框值
  // const storeOptions = stores?.map((store) =>
  //   <Option key={store.id} value={store.id}>{store.name}</Option>);

  // // 下拉框值
  // const cardDefinitionOptions = cardDefinitions?.map((cardDefinition) =>
  //   <Option key={cardDefinition.id} value={cardDefinition.id}>{cardDefinition.name}</Option>);
    // 下拉框值
    const storeOptions = stores?.map((store) =>
    <Option key={store.id} value={store.id}>{store.name}</Option>);

  // 搜索
  const onSearchKeyword = (e: { target: { value: React.SetStateAction<string | undefined>; }; }) => {
    // console.log(e.target.value);
    setSearchKeyword(e.target.value);
  };
  return (
    <div className="gutter-example">
      <BreadcrumbCustom breads={['教师管理']} />
      <Row gutter={16}>
        <Col className="gutter-row" md={24}>
          <div className="gutter-box">
            <Card title="教师管理" bordered={false} extra={
              <div>
                <Select placeholder="全部校区"
                  style={{ minWidth: 180, marginLeft: '10px' }} mode="multiple"
                  onChange={(value: any) => {
                    setFilterStoreIds(value);
                  }}
                // allowClear
                >
                  {storeOptions}
                </Select>
                <Input type='text' placeholder="请输入姓名" style={{ width: 160, marginLeft: '10px' }}
                  onChange={onSearchKeyword} onKeyPress={loadData} allowClear>
                </Input>
                <Button type="ghost" style={{ width: 100, marginLeft: '10px' }} icon={<SearchOutlined />} onClick={() => {
                  loadData();
                }}>搜索</Button>
                <Button type="primary" onClick={() => {
                  setTeacherVisible(true);
                }} icon={<PlusOutlined />}>
                  新增
                </Button>
              </div>
            }>
              <Table dataSource={teachers} columns={columns} pagination={false} 
              rowClassName={(record, index) => {
                if (record.enable) {
                  return 'teacherValid';
                } else {
                  return 'teacherInvalid';
                }
              }}
              />
              <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "10px" }}>
                <Pagination
                  defaultCurrent={pageNum}
                  total={pageTotal}
                  pageSize={pageSize}
                  hideOnSinglePage={false}
                  className="pagination"
                  onChange={onPageChange}
                  showSizeChanger
                  showTotal={total => `共计 ${total} 条`}
                />
              </div>
            </Card>
          </div>
        </Col>
      </Row>
      <Drawer
        title={teacherDetail ? "编辑教师" : "新增教师"}
        visible={teacherVisible}
        width={720}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onFinish} ref={formRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="name"
                label="姓名"
                rules={[{ required: true, message: '请输入姓名' }]}
              >
                <Input placeholder="请输入姓名" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="phone"
                label="联系电话"
                rules={[{ required: false, message: '请输入联系电话' }]}
              >
                <Input placeholder="请输入联系电话" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="sex"
                label="性别"
                rules={[{ required: true, message: '请选择性别' }]}
              >
                <Radio.Group >
                  <Radio value={1} >男</Radio>
                  <Radio value={0}>女</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="birthday"
                label="生日"
                rules={[{ required: false, message: '请选择生日' }]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="storeIds"
                label="门店"
                rules={[{ required: true, message: '请选择门店' }]}
              >
                <Select placeholder="请选择门店" mode="multiple" >
                  {storeOptions}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="remark"
                label="备注"
              >
                <Input placeholder="请输入备注" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </div>
  );
};

export default TeacherView;
